import React from 'react';
import { useTranslation } from 'react-i18next';
import SadFeedback from 'common/assets/icons/common/feedback/sad-feedback.png';
import NeutralFeedback from 'common/assets/icons/common/feedback/neutral-feedback.png';
import SatisfiedFeedback from 'common/assets/icons/common/feedback/satisfied-feedback.png';
import SatisfiedFeedbackChosen from 'common/assets/icons/common/feedback/satisfied-feedback-chosen.png';
import { trackAnalyticEvent } from 'common/utils/client-analytics.util';
import { captureMessage } from 'common/utils/error.util';
import { POST_PAYMENT_FEEDBACK_REACTIONS } from 'common/constants/feedback.constants';
import CloseIcon from 'common/assets/icons/common/signs/black-close-sign.svg';
import { observer, inject } from 'mobx-react';
import { useWindowSize } from 'common/utils/style.util';
import {
  Feedback,
  Close,
  ReactionsWrapper,
  Reaction,
  SatisfiedChosen,
  NegativeFeedback,
  SendButton,
  GetHelpButton,
  FeedbackTextSent,
} from './FeedbackForm.styled';

const { GOOD_REACTION, NEUTRAL_REACTION, BAD_REACTION } =
  POST_PAYMENT_FEEDBACK_REACTIONS;

const FeedbackForm = ({ AppStore }) => {
  const {
    isFeedbackFormOpened,
    setFeedbackFormOpened,
    isFeedbackFormInvisible,
    setFeedbackFormInvisible,
  } = AppStore;
  const { t } = useTranslation();
  const { height } = useWindowSize();
  const [chosenReaction, setChosenReaction] = React.useState(null);
  const [feedbackText, setFeedbackText] = React.useState('');
  const [formSent, setFormSent] = React.useState(false);
  const handleClose = () => {
    setFeedbackFormOpened(false);
    setTimeout(() => {
      setFeedbackFormInvisible(true);
    }, 7000);
  };
  const handleChosenReaction = (value) => {
    setChosenReaction(value);
    trackAnalyticEvent(value);
  };
  const handleGetHelp = () => {
    if (window.fcWidget) window.fcWidget.open();
    setFeedbackFormOpened(false);
    setTimeout(() => {
      setFeedbackFormInvisible(true);
    }, 7000);
  };
  const handleFeedbackTextChange = (event) =>
    setFeedbackText(event.target.value);
  const handleSendFeedback = (event) => {
    event.preventDefault();
    if (feedbackText !== '') {
      setTimeout(() => {
        setFeedbackFormOpened(false);
      }, 5000);
      setTimeout(() => {
        setFeedbackFormInvisible(true);
      }, 7000);
      captureMessage(`post-pay-fb: ${feedbackText}`);
      setFormSent(true);
    }
  };
  return (
    <Feedback
      expanded={
        chosenReaction === NEUTRAL_REACTION || chosenReaction === BAD_REACTION
      }
      open={isFeedbackFormOpened}
      innerHeight={height}
      formSent={formSent}
      isFeedbackFormInvisible={isFeedbackFormInvisible}
    >
      <Close>
        <h4>{t('common.transactionStatus.feedbackForm.header')}</h4>
        <img
          src={CloseIcon}
          alt="close the form"
          onClick={handleClose}
          aria-hidden="true"
        />
      </Close>
      <h4>{t('common.transactionStatus.feedbackForm.header')}</h4>
      {chosenReaction === null && (
        <>
          <h3>{t('common.transactionStatus.feedbackForm.question')}</h3>
          <ReactionsWrapper>
            <Reaction>
              <img
                src={SadFeedback}
                alt="negative reaction"
                onClick={() => handleChosenReaction(BAD_REACTION)}
                aria-hidden="true"
              />
            </Reaction>
            <Reaction>
              <img
                src={NeutralFeedback}
                alt="neutral reaction"
                onClick={() => handleChosenReaction(NEUTRAL_REACTION)}
                aria-hidden="true"
              />
            </Reaction>
            <Reaction>
              <img
                src={SatisfiedFeedback}
                alt="positive reaction"
                onClick={() => handleChosenReaction(GOOD_REACTION)}
                aria-hidden="true"
              />
            </Reaction>
          </ReactionsWrapper>
        </>
      )}
      {chosenReaction === GOOD_REACTION &&
        setTimeout(() => {
          setFeedbackFormOpened(false);
        }, 5000) &&
        setTimeout(() => {
          setFeedbackFormInvisible(true);
        }, 7000) && (
          <SatisfiedChosen>
            <img src={SatisfiedFeedbackChosen} alt="positive reaction chosen" />
            <h3>
              {t('common.transactionStatus.feedbackForm.positiveReaction')}
            </h3>
          </SatisfiedChosen>
        )}

      {(chosenReaction === NEUTRAL_REACTION ||
        chosenReaction === BAD_REACTION) && (
        <>
          <h3 className="feedbackQuestion">
            {t('common.transactionStatus.feedbackForm.question')}
          </h3>
          <ReactionsWrapper className="reactionsWrapper">
            <Reaction>
              <img
                src={SadFeedback}
                alt="negative reaction"
                onClick={() => handleChosenReaction(BAD_REACTION)}
                className="reaction"
                aria-hidden="true"
              />
            </Reaction>
            <Reaction>
              <img
                src={NeutralFeedback}
                alt=""
                onClick={() => handleChosenReaction(NEUTRAL_REACTION)}
                className="reaction"
                aria-hidden="true"
              />
            </Reaction>
            <Reaction>
              <img
                src={SatisfiedFeedback}
                alt="neutral reaction"
                onClick={() => handleChosenReaction(GOOD_REACTION)}
                className="reaction"
                aria-hidden="true"
              />
            </Reaction>
          </ReactionsWrapper>

          {formSent ? (
            <FeedbackTextSent>
              <h1>{t('common.transactionStatus.feedbackForm.done')}</h1>
              <h3 style={{ maxWidth: '250px' }}>
                {t('common.transactionStatus.feedbackForm.positiveReaction')}
              </h3>
            </FeedbackTextSent>
          ) : (
            <NegativeFeedback>
              <h3>
                {t('common.transactionStatus.feedbackForm.negativeReaction')}
              </h3>
              <form>
                <textarea
                  rows="4"
                  cols="50"
                  placeholder="Type your response here..."
                  onChange={handleFeedbackTextChange}
                />
                <SendButton
                  feedbackText={feedbackText}
                  onClick={handleSendFeedback}
                >
                  {t('common.transactionStatus.feedbackForm.send')}
                </SendButton>
              </form>
              <GetHelpButton onClick={handleGetHelp}>
                {t('common.transactionStatus.feedbackForm.getHelp')}
              </GetHelpButton>
            </NegativeFeedback>
          )}
        </>
      )}
    </Feedback>
  );
};
export default inject('AppStore')(observer(FeedbackForm));
